import React from 'react';

/** En-tête de page : titre, compteur/sous-titre, actions à droite (RTL-safe). */
const PageHeader = ({ title, description, actions, className = '' }) => (
  <div className={`mb-5 flex flex-wrap items-start justify-between gap-3 ${className}`}>
    <div className="min-w-0">
      <h1 className="text-3xl font-bold text-ink">{title}</h1>
      {description && <p className="mt-1 text-sm text-ink-subtle">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
  </div>
);

export default PageHeader;
